import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { UploadFileDropZone } from 'organisms/UploadFileDropzone'

export const ImportCustomerModal = ({ file, setFile, onUpload, fileLoading }) => {
  return (
    <React.Fragment>
      <Modal.Header>
        <div className="flex flex-row items-center justify-between">
          Import customers into Simplesat
          <a
            href="https://help.simplesat.io/articles/2482695-importing-customers-via-csv-file"
            target="_blank"
            rel="noreferrer"
            className="text-base font-normal"
          >
            <i className="icon far fa-book" /> Importing customers via CSV file
          </a>
        </div>
      </Modal.Header>
      <Modal.Content>
        <p>
          Importing a CSV file allows you to add and update customers stored in Simplesat. To
          import, please{' '}
          <a
            href="https://cdn.simplesat.io/files/import_customer_template.csv"
            target="_blank"
            rel="noreferrer"
          >
            download the template CSV file,
          </a>{' '}
          then update it with your customers.
        </p>
        <UploadFileDropZone
          file={file}
          fileName={file?.name || ''}
          setFile={setFile}
          loading={fileLoading}
          onUpload={onUpload}
          setHasError={() => {}}
          fileSizeLimit={50 * 1024 * 1024}
          instructionHeaderText="Drag and drop your CSV file here"
          description={
            <p>
              Your CSV must have an email address for each customer. Customer name, company, and any
              custom fields you choose will be automatically imported.
            </p>
          }
        />
        <Segment secondary>
          Or you can <Link to="/settings/integrations/">sync customer data to Simplesat</Link> to
          ensure your data is always up to date.
        </Segment>
      </Modal.Content>
    </React.Fragment>
  )
}

ImportCustomerModal.propTypes = {
  onUpload: PropTypes.func,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ImportCustomerModal/index.js